__turbopack_context__.v({
  "className": "allan_c23c6362-module__kGZzzq__className",
});
